import { render, staticRenderFns } from "./ManagementDetails.vue?vue&type=template&id=1b073a65"
import script from "./ManagementDetails.vue?vue&type=script&lang=js"
export * from "./ManagementDetails.vue?vue&type=script&lang=js"
import style0 from "./ManagementDetails.vue?vue&type=style&index=0&id=1b073a65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports